<template>
	<div class="notranslate">
		<div v-if="serviceItem" class='mb-4 row'>
			<div class="d-flex col-12 align-items-center">
				<div class="flex-grow-1">
					<div><b>{{ serviceItem.isDownPayment ? $t('service_down_payment') : $t('service_price')}}</b></div>
					<div>
						{{ getExchangedAmount(serviceTotal, 2) }}
					</div>
				</div>
				<div class="flex-shrink-0">
					<div class="ml-2 d-block d-sm-none text-right">
						{{ getExchangedAmount(serviceTotal, 2) }}
					</div>
				</div>
				<div class="d-none d-sm-block ml-2  flex-shrink-0 item-total">
					{{  getExchangedAmount(serviceTotal, 2) }}
				</div>
			</div>
		</div>
		<template v-if="cartItems.length">
			<div cy-data-row="cart-shopping-item" class='mb-4 row' v-for="item in cartItems" :key="key(item)">
				<div class="d-flex col-12 align-items-center">
					<div>
						<ding-image v-if="imageUrl(item)" class="mr-2 rounded-4" aspectRatio="16:9" width="100px" :src="imageUrl(item)" />
					</div>
					<div class="flex-grow-1">
						<div><b>{{titleForItem(item)}}</b></div>
						<div>
							<buyable-price
								:provider="provider"
								:cartItem="item"
								:item="itemForCartItem(item)"
								:spec="specForCartItem(item)"
								:show-pricing-rules="false"
							/>
						</div>
						<div v-if="false == itemForCartItem(item).should_count_for_free_logistic_rule">
							<small class="text-secondary">{{$t('not_count_for_free_shipping_rule')}}</small>
						</div>
					</div>
					<div class="flex-shrink-0">
						<item-count-control :item="itemForCartItem(item)" :spec="specForCartItem(item)" @count-changed="onCountChange" :group-amount-left="groupAmountLeftForCartItem(item)" />
						<div class="ml-2 d-block d-sm-none text-right">
							<buyable-total
								:start="cartStart"
								:end="cartEnd"
								:item="itemForCartItem(item)"
								:spec="specForCartItem(item)"
								:cartItem="item"
								:count="item.count"
								:provider="provider"
							/>
						</div>
					</div>
					<div class="d-none d-sm-block ml-2  flex-shrink-0 item-total">
						<buyable-total
							:start="cartStart"
							:end="cartEnd"
							:item="itemForCartItem(item)"
							:spec="specForCartItem(item)"
							:cartItem="item"
							:count="item.count"
							:provider="provider"
						/>
					</div>
				</div>
			</div>
		</template>
		<div v-if="cartBookingPassItem" class='mb-4 row'>
			<div class="d-flex col-12 align-items-center">
				<div>
					<ding-image v-if="cartBookingPassItem.bookingPass.image" class="mr-2 rounded-4" aspectRatio="16:9" width="100px" :src="imageUrlForBookingPass(cartBookingPassItem.bookingPass)" />
				</div>
				<div class="flex-grow-1">
					<div><b>{{cartBookingPassItem.bookingPass.title}}</b></div>
				</div>
				<div class="flex-shrink-0 item-total">
					{{ getExchangedAmount(bookingPassTotal, 2) }}
					<small><a href="javascript:void(0)" class="flex-shrink-0" @click="removeBookingPass()">{{ $t('general.cancel') }}</a></small>
				</div>
			</div>
		</div>
		<hr>
		<div class="mb-2 d-flex flex-wrap">
			<div cy-data-row="cart-campaign-item" v-for="campaign in appliedCampaigns" :key="campaign.id" v-b-tooltip.hover :title="campaign.description" class="label label-success w-auto">
				{{campaign.title}}
			</div>
		</div>
		<div v-if="currentCampaignManager?.campaignInConjunctionWithOthers && pointModuleIsEnabled && customer && pointsDeductableItemTotal > 0" class="text-left text-muted mb-2 d-flex align-items-end">
			<span class="text-nowrap">{{ $t('point_message_prepend') }}</span>
			<input type="number" class="form-control form-control-sm mx-1 text-right" min="0" :max="pointDeductedMax" style="max-width: 90px;"
				v-model="pointDeducted" @blur="validatePointsDeducted">
			<span class="text-nowrap">{{ $t('point_message_append') }}</span>
			<span class="text-nowrap mx-1"><small>{{ $t('customer_points', {points: customer.points}) }}</small></span>
			<div class="text-nowrap flex-grow-1 text-right">{{ getExchangedAmount(-pointDeductedAmount, 2) }}</div>
		</div>
		<div v-if="currentCampaignManager?.campaignInConjunctionWithOthers && showOfferSection" class="text-left text-muted mb-2">
			<div class="mb-1">{{$t('offers_label')}}</div>
			<div v-if="cartOfferItems.length">
				<div cy-data-row="cart-offer-item" v-for="item in cartOfferItems" :key="item.offer_id">
					<div class="text-right offer-item d-flex justify-content-between p-2">
						<div>
							<span>{{ item.offer.title }}</span>
							<small><a href="javascript:void(0)" class="flex-shrink-0" @click="removeOffer(item.offer)">{{ $t('general.cancel') }}</a></small>
						</div>
						<span v-if="isNaN(item.total)">--</span>
						<span v-else>{{ getExchangedAmount(-item.total, 2) }}</span>
					</div>
					<div class="white-space-pre-line" v-html="item.offer.description"></div>
				</div>
			</div>
			<div v-else>
				<button cy-button="enter-promo-code" class="btn btn-sm btn-outline-secondary w-100" @click="showPromoCodeEntryModal = true">
					{{$t('enter_promo_code')}}</button>
				<button v-if="hasLogInEnabled" class="btn btn-sm btn-outline-secondary w-100 mt-1" @click="attempToShowCouponSelectModal">
					{{$t('select_coupon')}}</button>
			</div>
		</div>
		<div class="text-right text-muted jt-0" v-if="cartItems.length">
			<small>{{$t('item_subtotal', { total: getExchangedAmount(itemTotal, 2) })}}</small>
		</div>
		<div class="text-right text-muted jt-0" v-if="serviceTotal > 0 && !context.autoRequestDownPayment">
			<small>{{$t('service_subtotal', { total: getExchangedAmount(serviceTotal, 2) })}}</small>
		</div>
		<div v-if="context.autoRequestDownPayment && downPaymentAmount > 0" class="text-right text-muted jt-0">
			<small>{{$t('deposit', { amount: getExchangedAmount(downPaymentAmount, 2) })}}</small>
		</div>
		<template v-if="cartCampaignItems.length">
			<div v-for="item in cartCampaignItems" :key="item.campaign_id" class="text-right text-muted jt-0">
				<small>{{item.campaign?.title || ''}}</small>
				<small>{{ isNaN(item.total) ? '--' : $t('offer_subtotal', { discount: getExchangedAmount(-item.total, 2) }) }}</small>
			</div>
		</template>
		<template v-if="cartOfferItems.length">
			<div v-for="item in cartOfferItems" :key="item.offer_id" class="text-right text-muted jt-0">
				<small>{{item.offer?.title || ''}}</small>
				<small>{{ isNaN(item.total) ? '--' : $t('offer_subtotal', { discount: getExchangedAmount(-item.total, 2) }) }}</small>
			</div>
		</template>
		<div v-if="pointDeductedAmount" class="text-right text-muted jt-0">
			<small>{{$t('points_subtotal', { amount: getExchangedAmount(-pointDeductedAmount) })}}</small>
		</div>
		<div class="text-right text-muted pt-0" v-if="logisticTotal">
			<small>{{$t('logistic_total', { total: getExchangedAmount(logisticTotal, 2) })}}</small>
		</div>
		<div class="text-right text-muted pt-0" v-if="cartEligibleForFreeShipping">
			<small>{{$t('free_shipping_eligible')}}</small>
		</div>
		<div class="text-right mt-3">
			{{$t('total', { total: getExchangedAmount(total, 2) })}}
		</div>
		<promo-code-entry-modal
			v-if="showPromoCodeEntryModal"
			:context="context"
			:provider="provider"
			:customer="customer"
			@close="showPromoCodeEntryModal = false"/>
		<coupon-select-modal
			v-if="showCouponSelectModal"
			:context="context"
			:provider="provider"
			:customer="customer"
			@close="showCouponSelectModal = false"/>
		<loading-indicator :clear-background="true" :full-parent="true" :is-loading="isLoading"></loading-indicator>
	</div>
</template>

<script>
import DingImage from '../components/common/Image.vue';
import { mapActions, mapGetters } from 'vuex';
import RootStore from '../stores/root';
import BuyablePrice from './items/BuyablePrice.vue';
import BuyableTotal from './items/BuyableTotal.vue';
import PromoCodeEntryModal from './PromoCodeEntryModal.vue';
import CouponSelectModal from './CouponSelectModal.vue';
import promptConfirm from '../mixins/prompt-confirm';
import { EventRemoveFromCart } from '../bu/models/GA4';
import api from '../mixins/api';
import CampaignManager from '../bu/CampaignManager';
import moment from 'moment';
import LoadingIndicator from './common/LoadingIndicator.vue';
import { getExchangedAmount } from '../bu/CurrencyUtils';

export default {
	components: { DingImage, BuyablePrice, BuyableTotal, PromoCodeEntryModal, CouponSelectModal, LoadingIndicator },
	store: RootStore,
	props: {
		context: {required: true, type: Object},
		provider: {required: true, type: Object}
	},
	mixins: [promptConfirm, api],
	computed: {
		...mapGetters({
			passes: 'booking-passes/bookingPasses',
			allCartItems: 'cart/items',
			items: 'items/items',
			itemMap: 'items/itemMap',
			specMap: 'items/specMap',
			itemTotal: 'cart/itemTotal',
			pointsDeductableItemTotal: 'cart/pointsDeductableItemTotal',
			logisticTotal: 'cart/logisticTotal',
			offerTotal: 'cart/offerTotal',
			serviceTotal: 'cart/serviceTotal',
			bookingPassTotal: 'cart/bookingPassTotal',
			serviceItem: 'cart/serviceItem',
			groupAmountLeftInfo: 'cart/groupAmountLeftInfo',
			customer: 'app/customer',
			totalItemCount: 'cart/totalItemCount',
			campaigns: 'campaigns/campaigns',
			cartEligibleForFreeShipping: 'cart/eligibleForFreeShipping',
			currency: 'currencies/currency',
			currencyRateMap: 'currencies/currencyRateMap',
			currencyOptions: 'currencies/currencyOptions',
			cartStart: 'cart/start',
			cartEnd: 'cart/end',
		}),
		hasLogInEnabled() {
			return !!(this.provider.login_setting && this.provider.login_setting.enabled);
		},
		hasLoggedIn() {
			return !!this.customer;
		},
		cartItems() {
			return this.allCartItems.filter((item) => item.count > 0 && (item.itemId || item.specId));
		},
		cartOfferItems() {
			return this.allCartItems.filter((item) => item.offer_id);
		},
		cartBookingPassItem() {
			return this.allCartItems.find((item) => item.booking_pass_id);
		},
		cartCampaignItems() {
			return this.allCartItems.filter((item) => item.campaign_id && item.total);
		},
		total() {
			const subtotal = 
				this.itemTotal 
				+ (+this.bookingPassTotal)
				+ this.serviceTotal
				+ (this.logisticTotal ?? 0) 
				- (this.offerTotal ? this.offerTotal : 0)
				- (this.pointDeductedAmount ? this.pointDeductedAmount : 0);
			if (subtotal > 0) {
				return subtotal;
			} else {
				return 0;
			}
		},
		showOfferSection() {
			return !!this.provider.offer_module_enabled;
		},
		downPaymentAmount() {
			if (this.context.autoRequestDownPayment) {
				return this.serviceTotal;
			} else {
				return 0;
			}
		},
		pointModuleIsEnabled() {
			return this.pointSetting?.is_enabled;
		},
		pointDeductedMax() {
			if (this.pointModuleIsEnabled) {
				let totalToPoints = 0;
				const subtotal = this.itemTotal
					+ this.serviceTotal
					- (this.offerTotal ?? 0);
				
				if (subtotal > 0 && this.pointsDeductableItemTotal > 0) {
					const amountToExchange = Math.min(subtotal, this.pointsDeductableItemTotal);
					totalToPoints = Math.floor(amountToExchange / this.pointSetting.rate_dollar * this.pointSetting.rate_point);
				}
				return Math.min(totalToPoints, this.customer?.points || 0);
			} else {
				return 0;
			}
		},
		pointDeductedAmount() {
			const points = parseInt(this.pointDeducted);
			if ((points && isNaN(points)) || !this.pointModuleIsEnabled) {
				this.pointDeducted = 0;
				return 0;
			} else if (this.pointModuleIsEnabled) {
				return Math.floor(points / this.pointSetting.rate_point * this.pointSetting.rate_dollar);
			}
		}
	},
	watch: {
		totalItemCount() {
			this.loadAppliedCampaigns();
		},
		offerTotal() {
			this.validatePointsDeducted();
		},
		cartStart() {
			this.loadAppliedCampaigns();
		},
		cartEnd() {
			this.loadAppliedCampaigns();
		},
		itemMap() {
			this.currentCampaignManager?.setItemMap(this.itemMap);
		},
		specMap() {
			this.currentCampaignManager?.setSpecMap(this.specMap);
		}
	},
	data() {
		return {
			isLoading: false,
			showPromoCodeEntryModal: false,
			showCouponSelectModal: false,
			pointSetting: null,
			pointDeducted: 0,
			currentCampaignManager: null,
			appliedCampaigns: []
		}
	},
	async mounted() {
		this.setProviderTimezoneToCart(this.provider.timezone);
		this.isLoading = true;
		this.getPointSetting((response, error) => {
			this.isLoading = false;
			if (error) {
				this.promptAlert(error);
			} else {
				this.pointSetting = Object.assign({}, response.data);
			}
		});

		this.isLoading = true;
		await this.getAvailableCampaigns();
		this.isLoading = false;
		this.currentCampaignManager = new CampaignManager(this.campaigns, this.itemMap, this.specMap);
		this.loadAppliedCampaigns();
	},
	beforeDestroy() {
		this.resetCart();
	},
	methods: {
		...mapActions({
			setProviderTimezoneToCart: 'cart/setProviderTimezone',
			setItem: 'cart/setItem',
			resetCart: 'cart/reset',
			removeOffer: 'cart/removeOffer',
			setPointsDeduction: 'cart/setPointsDeduction',
			setPointsDeductionTotal: 'cart/setPointsDeductionTotal',
			getAvailableCampaigns: 'campaigns/getAvailableCampaigns',
			setCampaigns: 'cart/setCampaigns',
			setOffer: 'cart/setOffer',
			removeBookingPass: 'cart/removeBookingPass',
		}),
		imageUrlForBookingPass(bookingPass) {
			return this.context.storageEndpoint + bookingPass.image.file_name;
		},
		attempToShowCouponSelectModal() {
			if (this.hasLoggedIn) {
				this.showCouponSelectModal = true;
			} else {
				this.promptAlert(this.$t('please_log_in_first_to_select_coupon'), () => {
					this.$emit('request-login');
				});
			}

		},
		groupAmountLeftForCartItem(targetCartItem) {
			var memo = Number.MAX_VALUE;
			for(var i in this.groupAmountLeftInfo) {
				const group = this.groupAmountLeftInfo[i];
				var isInGroup = false;
				if (targetCartItem.specId) {
					isInGroup = group.spec_ids.indexOf(targetCartItem.specId) >= 0;
				} else {
					isInGroup = group.item_ids.indexOf(targetCartItem.itemId) >= 0;
				}
				if (isInGroup) {
					var relatedCartItemCount = 0;
					for(var k in this.allCartItems) {
						const cartItem = this.allCartItems[k];
						if (cartItem.specId) {
							if (group.spec_ids.indexOf(cartItem.specId) >= 0) {
								relatedCartItemCount += cartItem.count;
							}
						} else if (group.item_ids.indexOf(cartItem.itemId) >= 0) {
							relatedCartItemCount += cartItem.count;
						}
					}
					const amountLeftConsideredCartItems = Math.max(0, group.amount_lefts - relatedCartItemCount);
					if(memo >= amountLeftConsideredCartItems) {
						memo = amountLeftConsideredCartItems;
					}
				}
			} 
			return memo === Number.MAX_VALUE ? null : memo;
		},
		onCountChange({item, spec, count}) {
			const cartItem = this.cartItems.find(cartItem => {
				if (spec) {
					return cartItem.specId == spec.id;
				} else {
					return cartItem.itemId == item.id;
				}
			});
			const countRecord = parseInt(cartItem.count);
			this.setItem({item, spec, count})
			const isRemovedFromCart = !this.cartItems.find(cartItem => {
				if (spec) {
					return cartItem.specId == spec.id;
				} else {
					return cartItem.itemId == item.id;
				}
			});
			if (isRemovedFromCart) {
				this.trackRemoveFromCart(item, countRecord, spec);
			}
		},
		key(cartItem) {
			var dateRange = "";
			if (cartItem.dateRange) {
				dateRange = JSON.stringify(cartItem.dateRange);
			}
			if (cartItem.specId) {
				return `key-${dateRange}-${cartItem.itemId}-${cartItem.specId}`;
			}
			return `key-${dateRange}-${cartItem.itemId}`;
		},
		imageUrl(cartItem) {
			if (cartItem.booking_pass_id) {
				const pass = this.passes.find((pass) => pass.id == cartItem.booking_pass_id);
				if (pass.image?.file_name) {
					return this.context.storageEndpoint + pass.image.file_name;
				}
			}
			if (cartItem.specId) {
				const spec = this.specForCartItem(cartItem)
				if (spec.image_path) {
					return this.context.storageEndpoint + spec.image_path;
				}
			}
			const item = this.itemForCartItem(cartItem);
			if (item.images && item.images.length > 0) {
				return this.context.storageEndpoint + item.images[0].file_name;
			}
			return null;
		},
		totalForItem(cartItem) {
			return this.priceForItem(cartItem) * cartItem.count
		},
		priceForItem(cartItem) {
			const spec = this.specForCartItem(cartItem);
			const item = this.itemForCartItem(cartItem);
			return parseInt(spec ? spec.price : item.price);
		},
		titleForItem(cartItem) {
			var title = this.itemForCartItem(cartItem).name;
			const spec = this.specForCartItem(cartItem);
			if (spec) {
				title += " " + spec.name;
			}
			return title;
		},
		itemForCartItem(cartItem) {
			return this.items.find((item) => item.id == cartItem.itemId)
		},
		specForCartItem(cartItem) {
			if (!cartItem.specId) {
				return null;
			}
			return this.itemForCartItem(cartItem).specs.find((spec) => spec.id == cartItem.specId)
		},
		validatePointsDeducted() {
			if (!this.pointModuleIsEnabled) {
				return
			}
			const points = parseInt(this.pointDeducted);
			if (isNaN(points) || points < 0) {
				this.pointDeducted = 0;
			} else if (points > this.pointDeductedMax) {
				this.pointDeducted = this.pointDeductedMax;
			} else {
				this.pointDeducted = Math.floor(this.pointDeductedAmount / this.pointSetting.rate_dollar * this.pointSetting.rate_point);
			}
			const payload = {
				total: this.pointDeductedAmount, // 折扣金額
				points_deducted: this.pointDeducted, // 花費點數
				point_setting: this.pointSetting
			};
			this.setPointsDeduction(payload);
			this.setPointsDeductionTotal(this.pointDeductedAmount);
		},
		trackRemoveFromCart(item, count, spec) {
			window.tracker.track(() => new EventRemoveFromCart(item, count, spec));
		},
		loadAppliedCampaigns() {
			if (!this.currentCampaignManager) {
				return;
			}

			const dateFormatStyle = 'YYYY-MM-DD HH:mm:ss';
			const start = this.cartStart ? moment.tz(this.cartStart, this.provider.timezone).format(dateFormatStyle) : null;
			const end = this.cartEnd ? moment.tz(this.cartEnd, this.provider.timezone).format(dateFormatStyle) : null;
			const levelId = this.customer?.level?.id;
			const serviceId = this.context.selectedService?.id;

			this.appliedCampaigns = this.currentCampaignManager.getValidCampaigns(
				levelId,
				serviceId,
				this.cartItems,
				null,
				start,
				end
			);

			this.getCampaignsDiscountAmount(this.allCartItems, start, end, levelId, serviceId, this.appliedCampaigns, (response, error) => {
				if (response?.data && Array.isArray(response.data)) {
					const campaigns = this.appliedCampaigns.map(campaign => {
						const data = response.data.find(item => item.offer_type === 'App\\Models\\ProviderCampaign' && item.offer_id === campaign.id);
						return {
							...campaign,
							discount: data ? data.discount_amount : 0
						}
					})
					this.setCampaigns({campaigns});

					const offerItem = this.allCartItems.find(item => item.offer_id);
					if (offerItem) {
						const offer = offerItem.offer;
						const data = response.data.find(item => item.offer_type === 'App\\Models\\Offer' && item.offer_id === offer.id);
						if (data) {
							offer.discount = data.discount_amount;
							if (!this.currentCampaignManager.campaignInConjunctionWithOthers) {
								this.removeOffer(offer);
							} else {
								if (offerItem.customer_offer_id) {
									this.setOffer({offer, customerOfferId: offerItem.customer_offer_id});
								} else {
									this.setOffer({offer});
								}
							}
						}
					}
				} else if (error) {
					const campaigns = this.appliedCampaigns.map(campaign => {
						return {
							...campaign,
							discount: '-'
						}
					})
					this.setCampaigns({campaigns});
					const offerItem = this.allCartItems.find(item => item.offer_id);
					if (offerItem) {
						const offer = offerItem.offer;
						offer.discount = '-';
						if (offerItem.customer_offer_id) {
							this.setOffer({offer, customerOfferId: offerItem.customer_offer_id});
						} else {
							this.setOffer({offer});
						}
					}
					const message = error.response?.data?.error;
					if (error.response.status !== 422 && message) {
						this.promptAlert(message);
					}
				}
				this.validatePointsDeducted();
			});
		},
		getExchangedAmount(amount, digits = 0) {
			return getExchangedAmount({
				rateMap: this.currencyRateMap,
				amount,
				from: this.provider.currency || 'TWD',
				to: this.currency,
				currencyOptions: this.currencyOptions,
				digits
			});
		},
		getAmountToTWD(amount) {
			return getExchangedAmount({
				rateMap: this.currencyRateMap,
				amount,
				from: this.provider.currency,
				to: 'TWD',
				currencyOptions: this.currencyOptions,
				digits: 0
			});
		},
	}
}
</script>

<style scoped lang="scss">

.rounded-4 {
	border-radius: 4px;
	overflow: hidden;
}

.flex-grow-1 {
	flex-grow: 1;
}

.flex-shrink-0 {
	flex-shrink: 0;
}

.item-total {
	min-width: 72px;
	text-align: right;
}

.offer-item {
	a {
		color: #007bff;
		text-decoration: none;
	}
}

</style>

<i18n>
{
	"en": {
		"item_subtotal": "Item subtotal {total}",
		"service_price": "Service",
		"service_down_payment": "Down Payment",
		"deposit": "Deposit {amount}",
		"offer_subtotal": " discount subtotal {discount}",
		"points_subtotal": "Points discount subtotal {amount}",
		"logistic_total": "Logistic subtotal {total}",
		"total": "Total {total}",
		"offers_label": "Promo code/Coupon",
		"enter_promo_code": "Enter promo code",
		"select_coupon": "Select coupon",
		"service_subtotal": "Service subtotal {total}",
		"please_log_in_first_to_select_coupon": "Please log in to select your coupons",
		"point_message_prepend": "Points deducted",
		"point_message_append": "point(s)",
		"customer_points": "(You have {points} points)",
		"free_shipping_eligible": "Eligible for free shipment",
		"checkout_twd_total": "Checkout Amount TWD {total}",
		"not_count_for_free_shipping_rule": "Not count for free shipping rule"
	},
	"zh": {
		"item_subtotal": "商品小計 {total}",
		"service_price": "預約項目費用",
		"service_down_payment": "訂金",
		"deposit": "訂金 {amount}",
		"offer_subtotal": " 折價 {discount}",
		"points_subtotal": "點數折抵 {amount}",
		"logistic_total": "物流費用小計 {total}",
		"total": "總計 {total}",
		"offers_label": "優惠碼/優惠券",
		"enter_promo_code": "輸入優惠碼",
		"select_coupon": "選擇優惠券",
		"service_subtotal": "預約項目費用小計 {total}",
		"please_log_in_first_to_select_coupon": "請先登入已選取優惠券",
		"point_message_prepend": "點數折抵",
		"point_message_append": "點",
		"customer_points": " (您擁有 {points} 點)",
		"free_shipping_eligible": "已達免運門檻",
		"checkout_twd_total": "結帳台幣約 {total}",
		"not_count_for_free_shipping_rule": "不計入免運數量"
	}
}
</i18n>